import axios from 'axios'
import contentTypeParser from 'content-type-parser'
// import Cookies from "js-cookie";
// import moment from "moment";
import appInfo from '../utils/appInfo'
import feedback from '../renew_v3/components/feedback'

// token在init上设
console.group(`app version ${appInfo.version}. ${appInfo.requestURL}`)
console.table(appInfo)
console.groupEnd()

const instance = axios.create({
  baseURL: appInfo.requestURL,
  // withCredentials: true,
  timeout: 10000,
  responseType: 'json'
})

Object.assign(instance.defaults.headers, {
  'Content-Type': 'application/json;charset=utf-8'
  // 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  // 'Access-Control-Allow-Headers': 'Content-Type',
  // 'Access-Control-Allow-Origin': 'http://manage-sd-fat2.lotussaid.com'
})

instance.setToken = function (token) {
  this.defaults.headers.common['Authorization'] = `Bearer ${token}`
  sessionStorage.setItem('token', token)
}.bind(instance)
instance.getToken = function () {
  let str = this.defaults.headers.common['Authorization']
  if (!str) {
    return ''
  } else {
    return str.slice(7)
  }
}
instance.clearToken = function () {
  this.defaults.headers.common['Authorization'] = null
  sessionStorage.setItem('token', null)
}

instance.interceptors.request.use((config) => {
  // const username = (config.headers && config.headers["username"]) || Cookies.get("username") || "unset";
  // config.headers && (config.headers["requestId"] = `${username}-${moment().unix()}-${Number.parseInt(String(Math.random() * 1000000))}`);
  if (config.params) {
    config.params = filterParams(config.params)
  }
  if (config.data) {
    config.data = filterParams(config.data)
  }
  if (appInfo.buildEnv === 'development') {
    console.group(`%c [request]${config.method}: ${config.url}`, 'color:#b175d6')
    console.log(config.params || config.data)
    console.log(config)
    console.groupEnd()
  }
  return config
})

instance.interceptors.response.use(function (response) {
  const contentType = contentTypeParser(response.headers['content-type'])
  // console.group('response', `[${response.config.method}]${response.config.url}`)
  // console.log(response)
  // console.groupEnd()
  if (appInfo.buildEnv === 'development') {
    console.group(` %c [response]${response.config.url}`, 'color:#35dbaf')
    console.log(response.data.data)
    console.log(response)
    console.groupEnd()
  }
  if (contentType.subtype !== 'json') {
    return Promise.reject(Error(`response content type error. [${contentType.subtype}]`))
  }
  const body = response.data
  if (body.desc !== 'ok') {
    // const reason = i18n.global.te(`code.${body.messageId}`)
    //   ? i18n.global.t(`code.${body.messageId}`)
    //   : i18n.global.t(`code.SERVICE_ERROR`)
    // return Promise.reject(Error(body.message))
    return Promise.reject({ response })
  }
  return body.data
})

export function filterParams (params) {
  const newParams = {}
  try {
    for (let k in params) {
      if (params[k] !== undefined && params[k] !== null) {
        Object.assign(newParams, { [k]: params[k] })
      }
    }
  } catch (e) {
    console.error(e)
  }
  return newParams
}

export function errHandler (e, showToast = true) {
  const { response } = e
  console.error(e)
  // if (response?.data?.message && showToast) {
  if (showToast && response && response.data && response.data.msg) {
    // 这里直接返回服务器的报错，如果要自定义显示就showToast为false然后再自己再外面展示吧...后面如果要匹配data.desc去做转译那后面再说
    feedback.toast.fail({ content: response.data.msg })
  }

// return MessagePlugin.error(error.message)
}

export const request = instance
